export enum FontStyle {
  normal,
  italic,
}
